<template>
    <div>
        <DxDropDownBox
            ref="dropDownBoxRefName"
            :drop-down-options="dropDownOptions"
            :data-source="geGridInfo"
            v-bind:value="currentValue"
            display-expr="성명"
            value-expr="사번"
            content-template="contentTemplate"
        >
          <template #contentTemplate="{}">
            <dx-data-grid ref='refGridEmployee'
              :data-source='geGridInfo'
              :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
              :selection="{ mode: 'single' }" :hover-state-enabled = "true" :allowColumnResizing = 'true'
              column-resizing-mode = 'widget' :allow-column-reordering = "true"
              :height='gridHeight'
              @selection-changed = "onSelectionChanged"
            >
              <DxSearchPanel
                :visible="true"
                placeholder="검색..."
              />
              <DxColumn
                :fixed="true"
                caption="사번"
                data-field="사번"
                width = '70'>
              </DxColumn>
              <DxColumn
                sort-order='asc'
                caption="성명"
                data-field="성명"
                width = '80'>
              </DxColumn>
              <DxColumn
                caption="소속"
                data-field="부서명"
                width = '80'>
              </DxColumn>
              <dx-paging :enabled="false"/>
              <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
              <dx-sorting mode="multiple"/>
            </dx-data-grid>
          </template>
        </DxDropDownBox>
    </div>
</template>

<script>
import DxDataGrid, { DxScrolling,
  DxColumn, DxPaging, DxSorting, DxSearchPanel } from 'devextreme-vue/data-grid'

import DxDropDownBox from 'devextreme-vue/drop-down-box'
export default {
  name: 'employeeGrid',
  data: function () {
    return {
      currentValue: null,
      dropDownOptions: { width: 300 },
      dataSource: null,
      gridHeight: 300
    }
  },
  props: {
    value: {
      type: String,
      default: null
    },
    gridInfo: {
      type: Array,
      default: null
    },
    onValueChanged: {
      type: Function,
      default: () => function (data) {
      }
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxScrolling,
    DxDropDownBox
  },
  computed: {
    geGridInfo () {
      return this.gridInfo
    }
  },
  created () {
    this.currentValue = this.value
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    initGrid () {
      if (this.$refs.refGridEmployee !== undefined) {
        this.$refs.refGridEmployee.instance.deselectAll()
      }
      this.currentValue = null
      this.$emit('selected-sabun', null)
      this.onValueChanged(null)
    },
    onSelectionChanged (e) {
      // console.log(this.currentValue)
      if (e.selectedRowsData.length === 0) {
        // console.log(e)
        return
      }
      this.currentValue = e.selectedRowsData[0].성명
      this.onValueChanged(e.selectedRowsData[0].성명)
      this.$emit('selected-sabun', e.selectedRowsData[0].사번)
      this.$refs.dropDownBoxRefName.instance.close()
    }
  }
}
</script>

<style lang="scss">

</style>
